import { createGlobalStyle } from 'styled-components';
import { ThemeInterface } from './ThemeInterface';
import { COMPACT_SCALE } from './breakpoints';

export const GlobalStyle = createGlobalStyle`
  /* IB-1885: the theme exposed as CSS custom properties, so plain CSS, embedded pages and later
     tenant branding can read and override one set of values instead of hard-coded hex codes. */
  :root {
    --ib-color-primary: ${(props: ThemeInterface) => props.theme.colors.primary};
    --ib-color-secondary: ${(props: ThemeInterface) => props.theme.colors.secondary};
    --ib-color-tertiary: ${(props: ThemeInterface) => props.theme.colors.tertiary};
    --ib-color-text: ${(props: ThemeInterface) => props.theme.colors.textDefault};
    --ib-color-background: ${(props: ThemeInterface) => props.theme.colors.htmlBackground};
    --ib-color-surface: ${(props: ThemeInterface) => props.theme.colors.surface};
    --ib-color-border: ${(props: ThemeInterface) => props.theme.colors.border};
    --ib-focus-ring: ${(props: ThemeInterface) => props.theme.colors.focusRing};
    --ib-radius-sm: ${(props: ThemeInterface) => props.theme.radii.sm};
    --ib-radius-md: ${(props: ThemeInterface) => props.theme.radii.md};
    --ib-shadow-sm: ${(props: ThemeInterface) => props.theme.shadows.sm};
    --ib-shadow-md: ${(props: ThemeInterface) => props.theme.shadows.md};
    --ib-ui-scale: 1;
  }

  /* Laptops (1024-1599px wide) render at the density users were getting by zooming the browser
     to 90%. Media queries still see the real viewport, so breakpoints are unaffected. */
  ${(props: ThemeInterface) => props.theme.media.compact} {
    :root {
      --ib-ui-scale: ${COMPACT_SCALE};
    }
    html {
      zoom: var(--ib-ui-scale);
    }
  }

  body, html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    scroll-behavior: smooth;
    color: ${(props: ThemeInterface) => props.theme.colors.textDefault};;
    font-family: ${(props: ThemeInterface) => props.theme.fontFamily};
    background-color: ${(props: ThemeInterface) => props.theme.colors.htmlBackground};
    font-feature-settings: 'liga', 'kern' 1;
    font-kerning: normal;
    -webkit-text-size-adjust: 100%;
  }

  body {
    line-height: 1.4;
    overflow-x: hidden;
  }

  #root {
    /* the zoomed page is drawn smaller, so it must be laid out taller to still fill the screen */
    min-height: calc(100vh / var(--ib-ui-scale));
    display: flex;
  }

  ::selection {
    background: ${(props: ThemeInterface) => props.theme.colors.focusRing};
  }

  /* Keyboard users get a visible focus ring; mouse clicks don't leave one behind. */
  a:focus-visible,
  button:focus-visible,
  [role='button']:focus-visible,
  input:focus-visible,
  select:focus-visible,
  textarea:focus-visible {
    outline: 2px solid var(--ib-focus-ring);
    outline-offset: 2px;
  }

  img,
  video,
  iframe {
    max-width: 100%;
  }

  /* Slimmer scrollbars, so the sidebar and scrolling tables don't lose a wide gutter. */
  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(61, 72, 74, 0.35) transparent;
  }
  *::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  *::-webkit-scrollbar-thumb {
    background-color: rgba(61, 72, 74, 0.35);
    border-radius: 999px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
`;
